/** Fill {name}-style slots in a translated string. */
export const fill = (template: string, vars: Record<string, string>): string =>
  template.replace(/\{(\w+)\}/g, (match, key) => (key in vars ? vars[key] : match));
